var generatorForm = {
    program: {
        name: "program",
        label: "Program",
        requiredErrorMsg: "Musíte zvolit program",
    },
    format: {
        name: "format",
        label: "Formát",
        requiredErrorMsg: "Vyberte požadovaný formát",
    },
    name: {
        name: "name",
        label: "Název projektu",
        requiredErrorMsg: "Název projektu je povinný",
        maxLength: 70,
        maxLengthErrorMsg: "Maximální délka názvu projektu je 70 znaků",
    },
    goal: {
        name: "goal",
        label: "Hlavní cíl projektu",
        requiredErrorMsg: "Cíl projektu je povinný",
        maxLength: 420,
        maxLengthErrorMsg: "Maximální délka cíle projektu je 420 znaků",
    },
    date: {
        name: "date",
        label: "Termín fyzické realizace projektu",
        requiredErrorMsg: "Dátum projektu je povinný",
    },
    cropMarks: {
        name: "cropMarks",
        label: "Chci PDF s ořezovými značkami.",
        requiredErrorMsg: "Povinné pole",
    },
    sponsorSelect: {
        name: "sponsorSelect",
        label: "Projekt je 100% financován ze zdrojů EU",
        requiredErrorMsg: "Povinné pole",
    },
    programSupport: {
        name: "programSupport",
        label: "Program podpory",
        requiredErrorMsg: "Povinné pole",
    }
};
export default generatorForm;
